export default "__VITE_ASSET__jcjHCHgj__"